import { useMemo } from 'react';

export enum LearnMoreLinkValidPages {
  PlanYourVisitTickets = '/plan-your-visit/',
  PlanYourVisitTicketsTicket = '/plan-your-visit/tickets/:ticketname',
  BuyTickets = '/buy-tickets/',
  CompareTickets = '/plan-your-visit/compare-tickets/',
}

export const useLearnMoreLink = (
  ticket: Queries.Maybe<Queries.SanityTicket>,
  page: LearnMoreLinkValidPages,
) => {
  const learnMoreLink = useMemo(() => {
    if (!ticket?.linkOverrides) return null;

    if (page === LearnMoreLinkValidPages.PlanYourVisitTickets) {
      return ticket?.url?.url;
    } else if (page === LearnMoreLinkValidPages.PlanYourVisitTicketsTicket) {
      return ticket.linkOverrides['planYourVisitPage'];
    } else if (page === LearnMoreLinkValidPages.BuyTickets) {
      return ticket.linkOverrides['buyTicketsPage'];
    } else if (page === LearnMoreLinkValidPages.CompareTickets) {
      return ticket.linkOverrides['compareTicketsPage'];
    }

    return null;
  }, [ticket, page]);

  return learnMoreLink;
};
